"use strict";exports.__esModule=true;exports.default=exports.getFile=exports.addFile=void 0;var fileStore={},addFile=function addFile(name){fileStore[name]=true},getFile=function getFile(name){return fileStore[name]};exports.getFile=getFile;exports.addFile=addFile;var _default={extension:function extension(FUSIONCHARTS){FUSIONCHARTS.addFile=addFile;FUSIONCHARTS.getFile=getFile},name:"fileStore",type:"plugin",requiresFusionCharts:true};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/constructor/src/constructor/file-store.js
// module id = oRM9
// module chunks = 5